/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationForAzureEa extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingInformationForAzureEa.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationForAzureEa>): BillingInformationForAzureEa {
        let obj = Object.assign(new BillingInformationForAzureEa(), model);
        BillingInformationForAzureEa.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationForAzureEa>): BillingInformationForAzureEa {
        if (!model) return null;
        return BillingInformationForAzureEa.newInstance(<BillingInformationForAzureEa> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationForAzureEa) {
        if (!obj) return;

        models.BillingInformationForAzureEa.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationForAzureEa): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationForAzureEa.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
